document.addEventListener('DOMContentLoaded', () => {
  const $elems = document.querySelectorAll(".js--waveicon-dialog-trigger");
  $elems.forEach(elem => {
    elem.addEventListener("click", (e) => {
      e.preventDefault();
      const dialog = e.currentTarget?.querySelector("dialog");
      dialog?.show();
      const closeBtn = dialog?.querySelector("span[close-btn]");
      closeBtn?.addEventListener("click", (e)=> {e.stopImmediatePropagation();dialog?.close()}, { once: true });
    })
  })
})